import { render, staticRenderFns } from "./productsPricesGraphics.vue?vue&type=template&id=e5136ce6"
import script from "./productsPricesGraphics.vue?vue&type=script&lang=js"
export * from "./productsPricesGraphics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports